export default __webpack_public_path__ + "static/media/GreaterThanIcon.9042a23d.svg";